import type { LanguageEntry } from './types';

export const LANGUAGES: readonly LanguageEntry[] = [
  { code: 'en', nativeName: 'English', englishName: 'English', dir: 'ltr', script: 'latin' },
  { code: 'zh', nativeName: '中文', englishName: 'Mandarin Chinese', dir: 'ltr', script: 'cjk' },
  { code: 'hi', nativeName: 'हिन्दी', englishName: 'Hindi', dir: 'ltr', script: 'devanagari' },
  { code: 'es', nativeName: 'Español', englishName: 'Spanish', dir: 'ltr', script: 'latin' },
  { code: 'fr', nativeName: 'Français', englishName: 'French', dir: 'ltr', script: 'latin' },
  { code: 'ar', nativeName: 'العربية', englishName: 'Arabic', dir: 'rtl', script: 'arabic' },
  { code: 'bn', nativeName: 'বাংলা', englishName: 'Bengali', dir: 'ltr', script: 'bengali' },
  { code: 'pt', nativeName: 'Português', englishName: 'Portuguese', dir: 'ltr', script: 'latin' },
  { code: 'ru', nativeName: 'Русский', englishName: 'Russian', dir: 'ltr', script: 'cyrillic' },
  { code: 'ur', nativeName: 'اردو', englishName: 'Urdu', dir: 'rtl', script: 'arabic' },
  {
    code: 'id',
    nativeName: 'Bahasa Indonesia',
    englishName: 'Indonesian',
    dir: 'ltr',
    script: 'latin',
  },
  { code: 'de', nativeName: 'Deutsch', englishName: 'German', dir: 'ltr', script: 'latin' },
  { code: 'ja', nativeName: '日本語', englishName: 'Japanese', dir: 'ltr', script: 'cjk' },
  { code: 'mr', nativeName: 'मराठी', englishName: 'Marathi', dir: 'ltr', script: 'devanagari' },
  { code: 'te', nativeName: 'తెలుగు', englishName: 'Telugu', dir: 'ltr', script: 'telugu' },
  { code: 'tr', nativeName: 'Türkçe', englishName: 'Turkish', dir: 'ltr', script: 'latin' },
  { code: 'ta', nativeName: 'தமிழ்', englishName: 'Tamil', dir: 'ltr', script: 'tamil' },
  { code: 'vi', nativeName: 'Tiếng Việt', englishName: 'Vietnamese', dir: 'ltr', script: 'latin' },
  { code: 'ro', nativeName: 'Română', englishName: 'Romanian', dir: 'ltr', script: 'latin' },
  { code: 'tl', nativeName: 'Tagalog', englishName: 'Tagalog', dir: 'ltr', script: 'latin' },
  { code: 'ko', nativeName: '한국어', englishName: 'Korean', dir: 'ltr', script: 'cjk' },
  { code: 'fa', nativeName: 'فارسی', englishName: 'Persian', dir: 'rtl', script: 'arabic' },
  { code: 'sw', nativeName: 'Kiswahili', englishName: 'Swahili', dir: 'ltr', script: 'latin' },
  { code: 'it', nativeName: 'Italiano', englishName: 'Italian', dir: 'ltr', script: 'latin' },
  {
    code: 'pa',
    nativeName: 'ਪੰਜਾਬੀ',
    englishName: 'Punjabi (Gurmukhi)',
    dir: 'ltr',
    script: 'gurmukhi',
  },
  { code: 'gu', nativeName: 'ગુજરાતી', englishName: 'Gujarati', dir: 'ltr', script: 'gujarati' },
  { code: 'th', nativeName: 'ภาษาไทย', englishName: 'Thai', dir: 'ltr', script: 'thai' },
  { code: 'pl', nativeName: 'Polski', englishName: 'Polish', dir: 'ltr', script: 'latin' },
  {
    code: 'uk',
    nativeName: 'Українська',
    englishName: 'Ukrainian',
    dir: 'ltr',
    script: 'cyrillic',
  },
  { code: 'nl', nativeName: 'Nederlands', englishName: 'Dutch', dir: 'ltr', script: 'latin' },
] as const;
